module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/housekeeping/css/profile.component.css
// module id = ./src/app/modules/housekeeping/css/profile.component.css
// module chunks = main